<template>
  <div class="page-block">
    <header-bar>Link設定画面</header-bar>
    <div
      class="single-column">
      <section class="single-column__section">
        <div class="release-info-area">
          <div
            class="relese-info-caption">
            <div class="relese-info-jaket c-gray-box__caption">
              <svg
                class="icon-add_jacket svg-icon"
                viewBox="0 0 26.5 24.994">
                <path
                  class="color1"
                  d="M14.436,0h-.012L1.458,2A1.5,1.5,0,0,0,0,3.494v18a1.479,1.479,0,
                  0,0,1.414,1.494h.01L14.5,24.994a1.5,1.5,0,0,0,1.5-1.5v-22A1.51,1.51,
                  0,0,0,14.436,0ZM15,23.494a.5.5,0,0,1-.424.506L1.5,21.994a.5.5,0,0,
                  1-.5-.5v-18a.5.5,0,0,1,.5-.5l13-2a.5.5,0,0,1,
                  .5.5Zm11.5-21v20h-10v-1h9v-18h-9v-1h10ZM16.5,20a7.571,7.571,0,0,0,
                  0-15.009L16.629,4a8.571,8.571,0,0,1,0,16.991Zm1.417-6.978A1.63,
                  1.63,0,0,0,16.9,10.953a.5.5,0,1,1,.323-.946,2.629,2.629,0,0,1,
                  .017,4.97.5.5,0,0,1-.33-.944A1.623,1.623,0,0,0,17.913,13.021Z" />
              </svg>
              ジャケット画像
            </div>
            <div class="relese-info-product c-gray-box__caption">
              <svg
                class="icon-add_product svg-icon"
                viewBox="0 0 17.044 23.033">
                <path
                  class="color1"
                  d="M1.322,23.033a1.352,1.352,0,0,1-.328-.041,1.325,1.325,0,0,
                  1-.968-1.54V1.507a1.057,1.057,0,0,1,0-.274A1.4,1.4,0,0,1,
                  1.585.011l11.148,0,.146.146c4.042,4.036,4.042,4.036,4.084,4.112a.5.5,0,
                  0,1-.807.579c-.188-.193-3.141-3.142-3.837-3.837H1.526a.453.453,0,0,
                  0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,21.631a.322.322,0,0,0,
                  .392.392l.124-.016,14.105.011a.338.338,0,0,0,.406-.261.349.349,
                  0,0,0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,0,
                  1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
                  1.507l4.407-.007.014,15.453a1.362,1.362,0,0,1-.012.509,1.341,
                  1.341,0,0,1-1.535,1.038H1.581A1.338,1.338,0,0,1,
                  1.322,23.033Zm2.2-12.526h10v-1h-10Zm0,3h10v-1h-10Zm0,3h6v-1h-6Z" />
              </svg>
              リリース情報
            </div>
          </div>
          <div class="release-info-area__wrap">
            <div class="release-info-area__pic release-info-area__pic--none">
              <img
                class="preview-image"
                :src="`/images/${coverart_filepath}`" />
            </div>
            <div class="release-info-area__list">
              <dl class="release-info-area__list-node">
                <dt class="release-info-area__list-title">メインアーティスト名</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.artist_name }}
                </dd>
              </dl>
              <dl class="release-info-area__list-node">
                <dt class="release-info-area__list-title">商品タイトル名</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.full_title || '未設定' }}
                </dd>
              </dl>
              <dl class="release-info-area__list-node">
                <dt class="release-info-area__list-title">商品タイトル名（カナ表記）</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.title_kana || '未設定' }}
                </dd>
              </dl>
              <dl class="release-info-area__list-node">
                <dt class="release-info-area__list-title">商品タイトル名（アルファベット表記）</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.title_en || '未設定' }}
                </dd>
              </dl>
              <dl class="release-info-area__list-node">
                <dt class="release-info-area__list-title">ジャンル</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.genre1 || '未設定' }}
                </dd>
              </dl>
              <dl class="release-info-area__list-node">
                <dt class="release-info-area__list-title">サブジャンル</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.genre2 || '未設定' }}
                </dd>
              </dl>
              <dl class="release-info-area__list-node">
                <dt class="release-info-area__list-title">レーベル</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.label_name_ja || '未設定' }}
                </dd>
              </dl>
              <dl
                v-if="isBtoB"
                class="release-info-area__list-node">
                <dt class="release-info-area__list-title">JANコード</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.jan || '未設定' }}
                </dd>
              </dl>
              <dl class="release-info-area__list-node">
                <dt class="release-info-area__list-title">発売実績</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.released | toReleasedType }}
                </dd>
              </dl>
              <dl
                v-if="item.released"
                class="release-info-area__list-node">
                <dt class="release-info-area__list-title">発売日</dt>
                <dd class="release-info-area__list-text release-info-area__list-text--notset">
                  {{ item.original_release_date | formatDate }}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div
      class="single-column white-bacckground">
      <section class="single-column__section white-bacckground">
        <div class="release-info-area white-bacckground">
          <form
            :class="{ 'form--error': errors }">
            <div class="profile-info white-bacckground">
              <div class="form-wrap form-wrap--profile u-no-margin-top white-bacckground">
                <div class="c-btn-wrap roote-btn white-bacckground">
                  <a
                    href="#"
                    class="c-btn c-btn--back c-btn--back-left roote-cange"
                    @click.prevent="onReleaseDetailClicked(item)">リリース情報詳細
                  </a>
                  <a
                    href="#"
                    class="c-btn roote-cange"
                    @click.prevent="onReleaseReportClicked(item)">アクセスレポート
                  </a>
                </div>
                <div class="form-group white-bacckground">
                  <div class="form-label">
                    <label
                      class="control-label white-bacckground"
                      for="link_domestic">公開設定
                    </label>
                  </div>
                  <div class="form-item white-bacckground">
                    <div class="form-item-inline white-bacckground">
                      <div class="radio">
                        <label for="product_link_show">
                          <input
                            id="product_link_show"
                            v-model="status"
                            type="radio"
                            name="product_link_status"
                            :value="1"
                            checked>
                          <div class="option-input"></div>公開
                        </label>
                      </div>
                      <div class="radio">
                        <label for="product_link_hide">
                          <input
                            id="product_link_hide"
                            v-model="status"
                            type="radio"
                            :value="0"
                            name="product_link_status">
                          <div class="option-input"></div>非公開
                        </label>
                      </div>
                    </div>
                    <div class="form-item-text">
                      ※【審査結果のご報告メール】が届いた翌日にLinkMAP画面が閲覧可能です。
                    </div>
                  </div>
                </div>
                <div class="form-group white-bacckground">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="link_domestic">リンク画面URL
                    </label>
                  </div>
                  <div class="form-item">
                    <span>{{ linkDomain }}/links/</span>
                    <input
                      v-if="isBtoB"
                      id="link_domestic"
                      v-model="url"
                      class="form-control link-form-control"
                      type="text"
                      placeholder="リンク画面URLを一部変更可能です。">
                    <input
                      v-else
                      id="link_domestic"
                      v-model="url"
                      class="form-control link-form-control"
                      type="text"
                      disabled>
                    <div class="form-item copy-btn">
                      <transition name="vcopy">
                        <p
                          v-if="hasCopied"
                          class="link-form-control click-message">
                          リンク画面URLをコピーしました。
                        </p>
                      </transition>
                    </div>
                    <div class="form-item copy-btn">
                      <p
                        v-if="errors.url"
                        class="error-text">
                        {{ errors.url[0] }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="c-btn--note"
                    @click.prevent="copyToClipBoardClicked()">
                  </div>
                </div>
                <div class="form-group white-bacckground">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="song_introduction_domestic">コメント
                    </label>
                  </div>
                  <div class="form-item">
                    <textarea
                      v-model="comment"
                      placeholder="リリースに対するコメントを入力してください。LinkMAP画面に表示されます"
                      class="c-textarea">
                    </textarea>
                    <p
                      v-if="errors.comment"
                      class="error-text">
                      {{ errors.comment[0] }}
                    </p>
                  </div>
                </div>

                <div class="store-title white-bacckground">
                  <p>ストリーミングストア</p>
                </div>
                <div class="form-group white-bacckground grab">
                  <div class="form-item-text">
                    <ul class="c-indent-list">
                      <li class="c-indent-list__node">
                        ストアの掲載順序はストア名称をドラッグアンドドロップすることで変更可能です。<br />
                        （ストリーミングストア、ダウンロードストアの範囲内で順序設定可能です）
                      </li>
                      <li class="c-indent-list__node">
                        ストアのURLが入力できるストアは、リリースのURLをご入力ください。
                      </li>
                      <li class="c-indent-list__node">
                        「非公開」にチェックを入れるとLinkMAP画面にチェックしたストアが表示されなくなります。
                      </li>
                      <li class="c-indent-list__node">
                        LinkMAP画面に表示されるアーティストプロフィールはマイアーティスト画面にて設定・編集できます。
                      </li>
                    </ul>
                  </div>
                </div>
                <draggable
                  v-model="fetchedReleaseLinksForStreaming"
                  handle=".link-form-label">
                  <transition-group>
                    <div
                      v-for="(releaseLink, index) in fetchedReleaseLinksForStreaming"
                      :key="`streaming-${index}`"
                      class="form-group white-bacckground">
                      <div class="link-form-label">
                        <label
                          class="control-label">
                          <span class="drag-drop-icon">
                            <svg
                              class="svg-icon"
                              width="24px"
                              height="24px"
                              viewBox="0 0 96.000000 96.000000">
                              <path
                                fill="#000000"
                                stroke="none"
                                d="
                        M33 83C32 83 31 82 30 81C28 79 28 76 28 60C28 41 28 41 31 39C34 36 34 36 51
                        36L68 36L68 32L68 28L72 28L76 28L76 32L76 36L77 36C78 36 80 37 81 38C84 40
                        84 40 84 60C84 78 83 80 82 82C80 83 78 84 57 84C45 84 34 84 33 83ZM63 71L64
                        69L63 68C62 67 62 66 62 66L62 65L65 65L69 64L64 60C62 58 58 54 56 52L52
                        48L52 59L52 71L54 69L57 67L57 67C58 67 58 69 59 70C60 72 61 73 63 71ZM21
                        59C18 58 16 55 16 51L16 48L20 48L24 48L24 54L24 60L23 60C23 60 22 60 21
                        59ZM16 34L16 28L20 28L24 28L24 34L24 40L20 40L16 40L16 34ZM16 19C16 19 17
                        17 19 15C21 13 22 12 25 12L28 12L28 16L28 20L22 20L16 20L16 19ZM40 16L40
                        12L46 12L52 12L52 16L52 20L46 20L40 20L40 16ZM64 16L64 12L67 12C71 12 74
                        15 75 18L76 20L70 20L64 20L64 16Z" />
                            </svg>
                          </span>
                          {{ releaseLink.release_provider_name }}
                        </label>
                      </div>
                      <div class="form-item">
                        <input
                          v-model="releaseLink.url"
                          class="form-control form-control--w600"
                          type="text"
                          :placeholder="releaseLink.is_api == 1 &&
                            !releaseLink.url_acquired_at
                            ?'配信'+
                              (releaseLink.key==='spotify'?'開始日に':'日が近づくと')+
                              'ストアのURLが自動で設定されます。入力はできません。'
                            : '入力してください'"
                          :disabled="releaseLink.is_api === 1 &&
                            !releaseLink.url_acquired_at">
                        <p
                          v-if="errors[`releaseLinks.${releaseLink.release_provider_id}.url`]"
                          class="error-text">
                          {{ errors[`releaseLinks.${releaseLink.release_provider_id}.url`][0] }}
                        </p>
                        <p
                          v-else-if="errors[`releaseLinks.addUrl${index}.url`]"
                          class="error-text">
                          {{ errors[`releaseLinks.addUrl${index}.url`][0] }}
                        </p>
                      </div>
                      <div class="privacy-checkbox">
                        <label>
                          <input
                            :id="index"
                            v-model="releaseLink.status"
                            true-value="0"
                            false-value="1"
                            type="checkbox">
                          <div class="option-input"></div>非公開
                        </label>
                      </div>
                    </div>
                  </transition-group>
                </draggable>

                <div class="store-title white-bacckground">
                  <p>ダウンロードストア</p>
                </div>
                <div class="form-group white-bacckground grab">
                  <div class="form-item-text">
                    <ul class="c-indent-list">
                      <li class="c-indent-list__node">
                        ストアの掲載順序はストア名称をドラッグアンドドロップすることで変更可能です。<br />
                        （ストリーミングストア、ダウンロードストアの範囲内で順序設定可能です）
                      </li>
                      <li class="c-indent-list__node">
                        ストアのURLが入力できるストアは、リリースのURLをご入力ください。
                      </li>
                      <li class="c-indent-list__node">
                        「非公開」にチェックを入れるとLinkMAP画面にチェックしたストアが表示されなくなります。
                      </li>
                      <li class="c-indent-list__node">
                        LinkMAP画面に表示されるアーティストプロフィールはマイアーティスト画面にて設定・編集できます。
                      </li>
                    </ul>
                  </div>
                </div>
                <draggable
                  v-model="fetchedReleaseLinksForDownload"
                  handle=".link-form-label">
                  <transition-group>
                    <div
                      v-for="(releaseLink, index) in fetchedReleaseLinksForDownload"
                      :key="`download-${index}`"
                      class="form-group white-bacckground">
                      <div class="link-form-label">
                        <label
                          class="control-label">
                          <span class="drag-drop-icon">
                            <svg
                              class="svg-icon"
                              width="24px"
                              height="24px"
                              viewBox="0 0 96.000000 96.000000">
                              <path
                                fill="#000000"
                                stroke="none"
                                d="
                        M33 83C32 83 31 82 30 81C28 79 28 76 28 60C28 41 28 41 31 39C34 36 34 36 51
                        36L68 36L68 32L68 28L72 28L76 28L76 32L76 36L77 36C78 36 80 37 81 38C84 40
                        84 40 84 60C84 78 83 80 82 82C80 83 78 84 57 84C45 84 34 84 33 83ZM63 71L64
                        69L63 68C62 67 62 66 62 66L62 65L65 65L69 64L64 60C62 58 58 54 56 52L52
                        48L52 59L52 71L54 69L57 67L57 67C58 67 58 69 59 70C60 72 61 73 63 71ZM21
                        59C18 58 16 55 16 51L16 48L20 48L24 48L24 54L24 60L23 60C23 60 22 60 21
                        59ZM16 34L16 28L20 28L24 28L24 34L24 40L20 40L16 40L16 34ZM16 19C16 19 17
                        17 19 15C21 13 22 12 25 12L28 12L28 16L28 20L22 20L16 20L16 19ZM40 16L40
                        12L46 12L52 12L52 16L52 20L46 20L40 20L40 16ZM64 16L64 12L67 12C71 12 74
                        15 75 18L76 20L70 20L64 20L64 16Z" />
                            </svg>
                          </span>
                          {{ releaseLink.release_provider_name }}
                        </label>
                      </div>
                      <div class="form-item">
                        <input
                          v-model="releaseLink.url"
                          class="form-control form-control--w600"
                          type="text"
                          :placeholder="releaseLink.is_api === 1 && !releaseLink.url_acquired_at
                            ? '配信日が近づくとストアのURLが自動で設定されます。入力はできません。' : '入力してください' "
                          :disabled="releaseLink.is_api === 1 &&
                            !releaseLink.url_acquired_at">
                        <p
                          v-if="errors[`releaseLinks.${releaseLink.release_provider_id}.url`]"
                          class="error-text">
                          {{ errors[`releaseLinks.${releaseLink.release_provider_id}.url`][0] }}
                        </p>
                        <p
                          v-else-if="errors[`releaseLinks.addUrl${index}.url`]"
                          class="error-text">
                          {{ errors[`releaseLinks.addUrl${index}.url`][0] }}
                        </p>
                      </div>
                      <div class="privacy-checkbox">
                        <label>
                          <input
                            :id="index"
                            v-model="releaseLink.status"
                            true-value="0"
                            false-value="1"
                            type="checkbox">
                          <div class="option-input"></div>非公開
                        </label>
                      </div>
                    </div>
                  </transition-group>
                </draggable>

                <div v-if="Object.keys(fetchedReleaseLinksForOther).length > 0">
                  <div
                    class="store-title white-bacckground">
                    <p>その他</p>
                  </div>
                  <div class="form-group white-bacckground grab">
                    <div class="form-item-text">
                      <ul class="c-indent-list">
                        <li class="c-indent-list__node">
                          ストアの掲載順序はストア名称をドラッグアンドドロップすることで変更可能です。<br />
                          （ストリーミングストア、ダウンロードストアの範囲内で順序設定可能です）
                        </li>
                        <li class="c-indent-list__node">
                          ストアのURLが入力できるストアは、リリースのURLをご入力ください。
                        </li>
                        <li class="c-indent-list__node">
                          「非公開」にチェックを入れるとLinkMAP画面にチェックしたストアが表示されなくなります。
                        </li>
                        <li class="c-indent-list__node">
                          LinkMAP画面に表示されるアーティストプロフィールはマイアーティスト画面にて設定・編集できます。
                        </li>
                      </ul>
                    </div>
                  </div>
                  <draggable
                    v-model="fetchedReleaseLinksForOther"
                    handle=".link-form-label">
                    <transition-group>
                      <div
                        v-for="(releaseLink, index) in fetchedReleaseLinksForOther"
                        :key="`other-${index}`"
                        class="form-group white-bacckground">
                        <div class="link-form-label">
                          <label
                            class="control-label">
                            <span class="drag-drop-icon">
                              <svg
                                class="svg-icon"
                                width="24px"
                                height="24px"
                                viewBox="0 0 96.000000 96.000000">
                                <path
                                  fill="#000000"
                                  stroke="none"
                                  d="
                        M33 83C32 83 31 82 30 81C28 79 28 76 28 60C28 41 28 41 31 39C34 36 34 36 51
                        36L68 36L68 32L68 28L72 28L76 28L76 32L76 36L77 36C78 36 80 37 81 38C84 40
                        84 40 84 60C84 78 83 80 82 82C80 83 78 84 57 84C45 84 34 84 33 83ZM63 71L64
                        69L63 68C62 67 62 66 62 66L62 65L65 65L69 64L64 60C62 58 58 54 56 52L52
                        48L52 59L52 71L54 69L57 67L57 67C58 67 58 69 59 70C60 72 61 73 63 71ZM21
                        59C18 58 16 55 16 51L16 48L20 48L24 48L24 54L24 60L23 60C23 60 22 60 21
                        59ZM16 34L16 28L20 28L24 28L24 34L24 40L20 40L16 40L16 34ZM16 19C16 19 17
                        17 19 15C21 13 22 12 25 12L28 12L28 16L28 20L22 20L16 20L16 19ZM40 16L40
                        12L46 12L52 12L52 16L52 20L46 20L40 20L40 16ZM64 16L64 12L67 12C71 12 74
                        15 75 18L76 20L70 20L64 20L64 16Z" />
                              </svg>
                            </span>
                            {{ releaseLink.release_provider_name }}
                          </label>
                        </div>
                        <div class="form-item">
                          <input
                            v-model="releaseLink.url"
                            class="form-control form-control--w600"
                            type="text"
                            :placeholder="releaseLink.is_api === 1 && !releaseLink.url_acquired_at
                              ? '配信日が近づくとストアのURLが自動で設定されます。入力はできません。' : '入力してください' "
                            :disabled="releaseLink.is_api === 1 &&
                              !releaseLink.url_acquired_at">
                          <p
                            v-if="errors[`releaseLinks.${releaseLink.release_provider_id}.url`]"
                            class="error-text">
                            {{ errors[`releaseLinks.${releaseLink.release_provider_id}.url`][0] }}
                          </p>
                          <p
                            v-else-if="errors[`releaseLinks.addUrl${index}.url`]"
                            class="error-text">
                            {{ errors[`releaseLinks.addUrl${index}.url`][0] }}
                          </p>
                        </div>
                        <div class="privacy-checkbox">
                          <label>
                            <input
                              :id="index"
                              v-model="releaseLink.status"
                              true-value="0"
                              false-value="1"
                              type="checkbox">
                            <div class="option-input"></div>非公開
                          </label>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="c-btn-wrap">
          <a
            href="#"
            class="c-btn c-btn--back c-btn--back-left"
            @click.prevent="onBackClicked">戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </a>
          <a
            href="#"
            class="c-btn"
            @click.prevent="onRegisterClicked()">登録する
            <span class="c-btn__icon-arrow"></span>
          </a>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import HeaderBar from '../HeaderBar'

export default {
  name: 'LinkCreate',

  components: {
    HeaderBar,
    draggable,
  },
  filters: {
    toReleasedType: (value) => (parseInt(value, 10) === 1 ? 'あり' : 'なし'),
  },
  data() {
    return {
      item: {},
      status: 1,
      url: '',
      comment: '',
      fetchedReleaseLinks: [],
      fetchedReleaseLinksForStreaming: [],
      fetchedReleaseLinksForDownload: [],
      fetchedReleaseLinksForOther: [],
      errors: [],
      coverart_filepath: null,
      linkDomain: '',
      dragStoreType: null,
      hasCopied: false,
    }
  },
  watch: {
    fetchedReleaseLinksForStreaming(newAry) {
      let counter = 0
      this.fetchedReleaseLinks.forEach((link, index) => {
        if (link.is_subscription === 1) {
          this.fetchedReleaseLinks.splice(index, 1, newAry[counter])
          counter += 1
        }
      })
    },
    fetchedReleaseLinksForDownload(newAry) {
      let counter = 0
      this.fetchedReleaseLinks.forEach((link, index) => {
        if (link.is_subscription === 0 && link.is_database_service === 0) {
          this.fetchedReleaseLinks.splice(index, 1, newAry[counter])
          counter += 1
        }
      })
    },
    fetchedReleaseLinksForOther(newAry) {
      let counter = 0
      this.fetchedReleaseLinks.forEach((link, index) => {
        if (link.is_subscription === null) {
          this.fetchedReleaseLinks.splice(index, 1, newAry[counter])
          counter += 1
        }
      })
    },
  },
  mounted() {
    this.fetchItem(this.$route.params.id)
  },
  methods: {
    async fetchItem(id) {
      try {
        // 楽曲情報取得&Link情報
        const response = await window.axios.get(`/api/client/links/${id}`)
        this.item = response.data
        this.releaseLinksLength = Object.keys(this.item.releaseLinks).length - 1
        this.item.title_kana = this.item.tracks.product.titles[1].title
        this.item.title_en = this.item.tracks.product.titles[2].title
        this.item.genre1 = this.item.genres[0].value
        if (Object.keys(this.item.genres).length === 2) {
          this.item.genre2 = this.item.genres[1].value
        }

        // リンク公開URLの初期値取得(初回登録)
        if (this.item.productLinks === null) {
          this.getUrl(this.$route.params.id)
          this.status = this.isBtoC ? 1 : 0
        } else {
          this.url = this.item.productLinks.url
          this.linkDomain = this.item.productLinks.link_domain
          this.status = this.item.productLinks.status
          this.comment = this.item.productLinks.comment
        }
        this.coverart_filepath = this.item.coverart_filepath

        this.fetchedReleaseLinks = this.item.releaseLinks
        this.fetchedReleaseLinks.forEach((link) => {
          if (link.is_subscription === 1) {
            this.fetchedReleaseLinksForStreaming.push(link)
          } else if (link.is_subscription === 0 && link.is_database_service === 0) {
            this.fetchedReleaseLinksForDownload.push(link)
          } else if (link.is_subscription === null) {
            this.fetchedReleaseLinksForOther.push(link)
          }
        })
      } catch ({ response }) {
        if (response.status === 404) {
          this.$router.push({ name: 'index' })
        }
      }
    },
    async getUrl(productId) {
      const randUrlData = await window.axios.get('/api/client/getRandUrl', { params: { product_id: productId } })
      this.url = randUrlData.data.url
      this.linkDomain = randUrlData.data.link_domain

      if (this.isBtoB) {
        this.status = 0
      }

      if (!this.url) {
        this.$set(this.errors, 'url', ['URLの生成に失敗しました'])
      }
    },
    compileFormData() {
      const params = this.fetchedReleaseLinks
      const formData = new FormData()
      formData.append('product_id', this.item.id)
      formData.append('url', this.url)
      formData.append('status', this.status)
      if (this.comment !== null) {
        formData.append('comment', this.comment)
      }
      params.forEach((inputData, index) => {
        Object.keys(inputData).forEach(atrName => {
          let reLeaseLinkSaveKey = inputData.release_provider_id
          if (!reLeaseLinkSaveKey) {
            reLeaseLinkSaveKey = `addUrl${index}`
          }
          let saveValue = inputData[atrName]
          if (saveValue === null) {
            saveValue = ''
          }
          formData.append(`releaseLinks[${reLeaseLinkSaveKey}][${atrName}]`, saveValue)
        })
      })
      return formData
    },
    async onRegisterClicked() {
      try {
        const config = { headers: { 'content-type': 'multipart/form-data' } }
        const formData = this.compileFormData()
        formData.append('_method', 'put')
        await window.axios.post(`/api/client/links/${this.$route.params.id}`, formData, config)
        window.location.href = '/client/links'
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
      }
    },
    onBackClicked() {
      this.$router.go(-1)
    },
    copyToClipBoardClicked() {
      // NOTE: httpsのみ動作可能
      const linkUrl = this.item.productLinks === null
        ? `${this.linkDomain}/links/${this.url}` // 初回登録前
        : this.item.productLinks.url_full // 登録済み

      try {
        window.navigator.clipboard.writeText(linkUrl)
        this.hasCopied = true
        setTimeout(() => {
          this.hasCopied = false
        }, '2000')
      } catch (error) {
        this.hasCopied = false
      }
    },
    async onReleaseDetailClicked(item) {
      const { data } = await window.axios.get(`/api/client/products/${item.id}/release`)
      window.sessionStorage.setItem('album', JSON.stringify(data))
      this.$router.push({ name: 'release-detail' })
    },
    async onReleaseReportClicked(item) {
      this.$router.push({ name: 'link-analytic-detail', params: { id: item.id } })
    },
  },
}
</script>

<style scoped>

.roote-btn {
  display: flex;
  justify-content: flex-end;
  margin: -30px 223px 0px 260px;
}

@media screen and (min-width: 896px) {
  .privacy-checkbox {
    display: inline-block;
  }
}

@media screen and (max-width: 895px) {
  .privacy-checkbox {
    margin-right: 4vw;
    font-size: 3.2vw;
  }
}

.privacy-checkbox label {
  position: relative;
  cursor: pointer;
  display: flex;
  font-weight: 500;
  white-space: nowrap
}

@media screen and (min-width: 896px) {
  .privacy-checkbox label {
    font-size: 1.4rem;
    line-height: 30px;
    max-width: 500px;
  }
}
@media screen and (max-width: 895px) {
  .privacy-checkbox label {
    line-height: 30px;
    margin-left: 10px;
  }
}

.privacy-checkbox input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.privacy-checkbox input:checked ~ .option-input:before {
  background:
    url(/images/icon-checkbox.png?4c740eca748cf87229f051d1faecfc42) no-repeat center center;
  background-size: 100% auto;
}

.privacy-checkbox .option-input {
  position: relative;
  margin: 0;
  padding-left: 35px;
  cursor: pointer;
  margin-right: 10px;
}

.privacy-checkbox .option-input:before {
  position: absolute;
  z-index: 1;
  top: 9px;
  left: 17px;
  width: 12px;
  height: 12px;
  content: "";
  background: #fff;
}

.privacy-checkbox .option-input:after {
  position: absolute;
  top: 2px;
  left: 0;
  width: 24px;
  height: 24px;
  content: "";
  border: 1px solid #d4cdc8;
  background: #ffffff;
  margin-left: 10px;
}

.link-form-label {
  position: relative;
}

.link-form-label label {
  font-weight: bold;
  position: relative;
}

@media screen and (min-width: 896px) {
  .link-form-label label {
    display: flex;
    align-items: center;
  }
}

@media screen and (min-width: 896px) {
  .link-form-label {
    width: 280px;
    font-size: 1.4rem;
    overflow-wrap: break-word;
    word-break:keep-all;
    display: flex;
    align-items: center;
  }
}

@media screen and (max-width: 895px) {
  .link-form-label {
    font-size: 3.2vw;
    margin-bottom: 0.6666666667vw;
  }
}
@media screen and (min-width: 896px) {
  .preview-image {
    width: 240px;
    height: 240px;
  }
}

@media screen and (max-width: 895px) {
  .preview-image {
    width: 50vw;
    height: 50vw;
  }
}

@media screen and (max-width: 895px) {
  .preview-image {
    width: 50vw;
    height: 50vw;
  }
}

.white-bacckground {
  background-color: #fff;
  border-bottom: none;
}
.roote-cange {
  background: rgb(255, 49, 49);
}

.link-form-control {
  width: 502px;
}

@media screen and (max-width: 895px) {
  .roote-btn {
    margin: 0;
    width: 100%;
    width: -502px;
    font-size: 3.7333333333vw;
    display: inline-block;
  }
  .roote-cange{
    width: 100%;
  }
}

@media screen and (max-width: 895px) {
  .roote-cange {
    width: 100%;
  }
}

@media screen and (max-width: 895px) {
  .store-title {
    margin-top: 30px;
    border-bottom: 2px solid #9F9F9F;
  }
  .store-title p {
    padding-left: 6px;
    font-weight: bold;
  }
}

@media screen and (min-width: 896px) {
  .store-title {
    margin-top: 20px;
    margin-left: 30px;
    margin-right: 30px;
    border-bottom: 2px solid #9F9F9F;
  }
  .store-title p {
    padding-left: 6px;
    font-weight: bold;
    font-size: 18px;
  }
}

.link-form-label {
  cursor: grab !important;
}

@media screen and (min-width: 896px) {
  .drag-drop-icon svg{
    height: 24px;
    margin-right: 10px;
    margin-top: 2px;
    width: auto;
  }
}
@media screen and (max-width: 895px) {
  .drag-drop-icon svg {
    height: 6.4vw;
    margin-right: 2.6666666667vw;
    margin-top: -0.2666666667vw;
    width: auto;
  }
}
.click-message{
  margin-top:5px;
  color:#2B2B2B;
  background-color:#FFAEB9;
  text-align:center;
}
.vcopy-enter-active, .vcopy-leave-active {
    transition: opacity 1s
}

.vcopy-enter, .vcopy-leave-to{
    opacity: 0;
}
</style>
